module.exports = __webpack_public_path__ + "static/media/logo.18c65fa6.svg";